export default __webpack_public_path__ + "static/media/Soulstorm.e6f140d1.jpg";